<template>
  <span v-if="showEnvBadge"
        class="env-badge d-inline-flex align-items-center gap-1"
        :title="`Release: ${releaseName} — Build: ${buildTime}`"
        style="font-size: 0.7rem; white-space: nowrap; user-select: none; cursor: help;">
    <span class="env-dot" :class="envDotClass"></span>
    <span class="env-label">{{ environmentLabel }}</span>
  </span>
</template>

<script>
function detectEnvironment () {
  const env = (process.env.VUE_APP_ENV || '').toLowerCase()
  if (env === 'development' || env === 'homologation') return env

  // Fallback automático via hostname
  const host = window.location.hostname
  if (host === 'localhost' || host === '127.0.0.1') return 'development'
  if (host.includes('homolog') || host.includes('staging') || host.includes('test')) return 'homologation'

  return 'production'
}

export default {
  name: 'EnvironmentBadge',
  props: {
    releaseName: { type: String, default: '' },
    buildTime: { type: String, default: '' }
  },
  computed: {
    environment () {
      return detectEnvironment()
    },
    showEnvBadge () {
      return this.environment === 'development' || this.environment === 'homologation'
    },
    environmentLabel () {
      const labels = { development: 'DEV', homologation: 'HOMOLOG' }
      return labels[this.environment] || ''
    },
    envDotClass () {
      return this.environment === 'development' ? 'env-dev' : 'env-homolog'
    }
  }
}
</script>

<style scoped>
.env-badge {
  line-height: 1;
  opacity: 0.85;
  transition: opacity 0.2s ease;
}
.env-badge:hover {
  opacity: 1;
}
.env-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  animation: pulse-dot 2s ease-in-out infinite;
}
.env-dev {
  background-color: #2ecc71;
  box-shadow: 0 0 4px rgba(46, 204, 113, 0.6);
}
.env-homolog {
  background-color: #f1c40f;
  box-shadow: 0 0 4px rgba(241, 196, 15, 0.6);
}
.env-label {
  color: rgba(255, 255, 255, 0.8);
  font-weight: 600;
  letter-spacing: 0.03em;
}
@keyframes pulse-dot {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}
</style>
